var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',_vm._g(_vm._b({staticClass:"base-tab__tabs",attrs:{"color":"blue","slider-color":"blue"}},'v-tabs',[_vm.$attrs, _vm.$props],false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }